import {
  //
  ADD_SETTINGS,
  ADD_SETTINGS_FAILURE,
  ADD_SETTINGS_SUCCESS,
  //
  DELETE_SETTINGS,
  DELETE_SETTINGS_FAILURE,
  DELETE_SETTINGS_SUCCESS,
  //
  EDIT_SETTINGS,
  EDIT_SETTINGS_FAILURE,
  EDIT_SETTINGS_SUCCESS,
  //
  FETCH_SETTINGS,
  FETCH_SETTINGS_FAILURE,
  FETCH_SETTINGS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
} from "./constants";

// List
export const fetchSettings = (payload) => ({
  type: FETCH_SETTINGS,
  payload,
});
export const fetchSettingsSuccess = (payload) => ({
  type: FETCH_SETTINGS_SUCCESS,
  payload,
});
export const fetchSettingsFailure = (payload) => ({
  type: FETCH_SETTINGS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addSettings = (payload) => ({
  type: ADD_SETTINGS,
  payload,
});
export const addSettingsSuccess = (payload) => ({
  type: ADD_SETTINGS_SUCCESS,
  payload,
});
export const addSettingsFailure = (payload) => ({
  type: ADD_SETTINGS_FAILURE,
  payload,
});
// EDIT
export const editSettings = (payload) => ({
  type: EDIT_SETTINGS,
  payload,
});
export const editSettingsSuccess = (payload) => ({
  type: EDIT_SETTINGS_SUCCESS,
  payload,
});
export const editSettingsFailure = (payload) => ({
  type: EDIT_SETTINGS_FAILURE,
  payload,
});
// DELETE
export const deleteSettings = (payload) => ({
  type: DELETE_SETTINGS,
  payload,
});
export const deleteSettingsSuccess = (payload) => ({
  type: DELETE_SETTINGS_SUCCESS,
  payload,
});
export const deleteSettingsFailure = (payload) => ({
  type: DELETE_SETTINGS_FAILURE,
  payload,
});
